import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WithSubscriptionComponent, ModalOpenerService } from '@sabstravtech/obtservices/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-modal-iframe',
  templateUrl: './modal-iframe.component.html',
  styleUrls: ['./modal-iframe.component.scss'],
  standalone: false
})
export class ModalIframeComponent
  extends WithSubscriptionComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('iframe') iframe: ElementRef;
  public loaded: any;
  public title = '';
  public urlForIframe = '';

  constructor(
    public modalOpenerService: ModalOpenerService,
    public dialogref: NgbActiveModal
  ) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.iframe.nativeElement.addEventListener('load', this.iframeTest.bind(this));
  }

  iframeTest(e): void {
    console.log('=== Iframe Loaded ===');
    this.loaded = true;
  }
}
LightningModalTypes.ModalIframeComponent.component = ModalIframeComponent;
